<template>
  <div class="picture-tab">
    <div class="picture-container">
      <div
        v-if="selectedBackImageResource.length >0"
        v-loading="isLoading"
        :class="{  'picture-list': true}"
        style="overflow-y: scroll"
      >
        <div
          v-for="(item, index) in selectedBackImageResource"
          :key="item.resourceId"
          class="picture-style"
          @mouseenter="handleOver(index, item)"
          @mouseleave="handleOut"
          @mousedown="judgeDraggable(item)"
        >
          <i
            v-show="mouseTarget === index"
            class="el-icon-circle-plus-outline picture-plus-icon"
            title="添加"
            @click="handlePictureIconAdd(item)"
          ></i>
          <i
            v-show="mouseTarget === index"
            class="el-icon-delete picture-delete-icon"
            title="删除"
            @click="handleDeleteBackImage(index)"
          ></i>
          <el-image
            fit="contain"
            lazy
            :src="item.resourceUrl"
            :draggable="item.duration"
            @dragstart="
              handlePictureStart({
                e: $event,
                item: item,
                index: index,
                list: 'backImageTrackList',
                prefix: 'backImage',
                trackId: 'backImageTrack',
                isTrackDrag: false
              })
            "
            @drag="handlePictureDragging"
            @dragend="handlePictureDragEnd"
          >
            <el-image slot="error" fit="contain" src="xx" style="height:50px"></el-image>
          </el-image>
          <div class="picture-style-title">{{item.resourceName}}</div>
        </div>
      </div>
      <div v-else class="picture-empty">
        <span>暂无背景</span>
      </div>
      <div class="button-style">
        <el-button @click="handleOpenDialog">历史上传</el-button>
        <el-upload
          class="location-upload"
          action="#"
          accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF"
          :disabled="isUploading"
          :multiple="false"
          :show-file-list="false"
          :http-request="uploadFile"
          element-loading-text="上传中，请稍后……"
        >
          <div class="methods-button">
            <el-button
              size="medium"
              type="primary"
              :disabled="isUploading"
              :loading="isUploading"
              >本地上传</el-button
            >
          </div>
        </el-upload>
        <!-- <span class="message"> 本地仅支持上传PNG格式贴图</span>s s s s -->
      </div>
    </div>
    <el-card v-show="isShowCard" v-loading="isCardLoading" class="picture-card">
      <el-image
        fit="contain"
        :src="cardSrc"
        @load="loadedCardContent"
      ></el-image>
    </el-card>
    <el-dialog
      :visible.sync="backImageDialog"
      width="80%"
      :before-close="handleClose"
    >
    <template slot="title">
      <div>历史上传-背景图</div>
    </template>
      <div>
        <CommonCardPageList v-if="backImageDialog" :type="0" :spaceInfo="spaceInfo" @select-card="handleSelectCard">
        </CommonCardPageList>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { commonUploadFile } from '@/views/mediaFactory/utils/upload'
import CommonCardPageList from '@/components/common/CommonCardPageList'

export default {
  components: {
    CommonCardPageList
  },
  props: {
    pictureRotate: {
      type: Number,
      default: 0
    },
    spaceInfo: {
      type: Object,
      default: () => {

      }
    }
  },
  data() {
    return {
      backImageDialog: false,
      mouseTarget: null,
      isLoading: false,
      cardSrc: '',
      isCardLoading: false,
      isUploading: false,
      pagination: {
        currentPage: 1,
        pageSize: 20
      },
      isShowCard: false
    }
  },
  computed: {
    ...mapState({
      selectedTarget: state => state.selectedTarget,
      playingBackImage: state => state.playingBackImage,
      playingBackImageIndex: state => state.playingBackImageIndex,
      backImageTrackList: state => state.backImageTrackList,
      activeName: state => state.activeName,
      selectedBackImageResource: state => state.selectedBackImageResource
    })
  },
  methods: {
    ...mapMutations({
      handlePictureStart: 'dragStart',
      handlePictureDragging: 'tabDragging',
      handlePictureDragEnd: 'tabDragEnd'
    }),
    handleOver(index, item) {
      this.mouseTarget = index
      this.cardSrc = item.resourceUrl
      this.isShowCard = true
    },
    handleOut(e) {
      this.isCardLoading = false
      this.mouseTarget = null
      this.isShowCard = false
    },
    handlePictureIconAdd(e) {
      if (!e.duration) {
        return false
      }
      if (this.backImageTrackList[0].length > 0 && this.backImageTrackList[0][0].resourceId === e.resourceId) {
        this.$message('背景已选用')
        return
      }
      this.$emit('icon-add', 'backImage', e)
    },
    handleDeleteBackImage(index) {
      this.$store.commit('deletBackIamgeResource', index)
      this.isShowCard = false
    },
    uploadFile(paramsFile) {
      this.isUploading = true
      const that = this
      let callback = function (e) {
        e.then(res => {
          that.isUploading = false
          if (res.code === 0) {
            that.handleSetBackImageSourece(res.data)
          } else {
            that.$message.error(res.message)
          }
        }).catch((error) => {
          that.isUploading = false
          that.$notify({
            title: '操作失败',
            type: 'error',
            message: error.message
          })
        })
      }
      commonUploadFile(paramsFile, 0, this.spaceInfo.spaceId, callback)
    },
    judgeDraggable(e) {
      if (!e.duration) {
        this.$message('素材加载中，右侧预览加载完毕后方可添加')
        return false
      }
      return true
    },
    loadedCardContent(e) {
      this.isCardLoading = false
      let targetList = this.selectedBackImageResource
      if (e.target.src === this.cardSrc) {
        const index = targetList.findIndex(item => {
          return item.resourceUrl === this.cardSrc
        })
        targetList[index].duration = 10
        targetList[index].loaded = true
      }
    },
    handleOpenDialog() {
      this.backImageDialog = true
    },
    handleClose() {
      this.backImageDialog = false
    },
    handleSelectCard(data) {
      this.handleSetBackImageSourece(data)
    },
    handleSetBackImageSourece(data) {
      if (this.selectedBackImageResource.findIndex(item => item.md5 === data.md5) > -1) {
        this.$message('背景已选择')
      } else {
        this.$store.commit('setBackIamgeResource', data)
        this.backImageDialog = false
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.picture-tab
  position relative
  height 100%
  &:focus
    outline 0px
.picture-list
  height 80%
  user-select none // 禁止选中 避免在不允许拖拽的情况下 使用浏览器默认选中行为后再进行拖拽
  // max-height 220px
.local-picture-list
  height auto
.picture-draggable
  width fit-content
  height 100%
  outline 0px
.picture-style
  display inline-block
  position relative
  margin 5px 0
  width 170px
  border 2px solid #f2f2f2
  border-radius 3px
  background #ececec
  transition all .3s
  &:hover
    border-color #ff8b00
  .el-image
    width 100%
    height 100%
    border-radius 3px 3px 0 0
.picture-plus-icon,
.picture-delete-icon
  position absolute
  top 1px
  font-size 15px
  font-weight 600
  cursor pointer
  z-index 2
  color #fff
.picture-plus-icon
  right 1px
.picture-delete-icon
  left 3px
.operation-tab
  padding 30px 10px
  span
    display inline-block
    width 10%
    text-align center
    vertical-align super
.operation-area
  display inline-block
  width 85%
  height 50px
  vertical-align middle
  >>>.el-slider__runway
    height 2.5px
    .el-slider__bar
      height 2.5px
    .el-slider__button
      width 10px
      height 10px
.el-icon-d-caret
  margin-right 20px
  vertical-align middle
  font-size 23px
  line-height 35px
  cursor pointer
  &:hover
    color #ff8b00
.horizontal-icon
  transform rotate(90deg)
.icon-ban
  color #ccc
  cursor default
  &:hover
    color #ccc
    cursor default
.picture-card
  position absolute
  top 0px
  right -200px
  width 200px
  height 140px
  background #d7d7d7
  border-color #d7d7d7
  z-index 3
  >>>.el-card__body
    position relative
    top 50%
    height inherit
    text-align center
    transform translateY(-50%)
  .el-image
    width 100%
    height 100%
  video
    width 100%
    height 100%
.mouse-image
  position fixed
  top 0px
  left 0px
  z-index 9999
  pointer-events none
.picture-container
  position relative
  height 100%
  overflow hidden
.category-container
  margin-bottom 10px
.category-style
  display inline-block
  margin 3px
  padding 0px 5px
  max-width 80px
  height 25px
  line-height 25px
  text-align center
  font-size 12px
  color #999
  border 1px solid #fff
  border-radius 5px
  background #fff
  cursor pointer
  transition all .3s
  &:hover
    border 1px solid #ff8b00
    color #ff8b00
.category-active
  border 1px solid #ff8b00
  color #ff8b00
.picture-empty
  height 20vh
  line-height 20vh
  font-size 13px
  text-align center
  color #aaa
.button-style
  position absolute
  bottom 5px
  // 避免遮住滚动条
  width 99%
  background #f2f2f2
.location-upload
  display inline-block
  margin-left 8px
  // margin 10px 3px 3px 3px
.picture-icons
  position absolute
  // bottom 0px
  right 0px
  i
    margin-right 10px
    font-size 18px
    cursor pointer
    &:hover
      color #ff8b00
.active-picture-list
  color #ff8b00
// .methods-button
//   width 100px
//   height 30px
//   line-height 10px
//   font-size 13px
//   color #888
//   border 1px solid #777
//   &:focus
//     background #fff
//   &:hover
//     color #ff8b00
//     border-color #ff8b00
//     background #fff
.message
  font-size 12px
  color #ccc
  cursor default
  vertical-align middle
::-webkit-scrollbar
  width 5px
  height 5px
::-webkit-scrollbar-thumb
  border-radius 5px
  background-color #ccc
.picture-style-title
  padding 0px 2px 4px
  width 100%
  font-size 12px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  cursor default
</style>
